import type { EmployeeListResponse, SendSmsResponse } from '@/types/employee';
import { api, isApiError } from './client';

export const getEmployees = async (signal?: AbortSignal): Promise<EmployeeListResponse> => {
  return api.get<EmployeeListResponse>('/api/employees', { signal });
};

export const sendTsdLoginSms = (employeeId: string): Promise<SendSmsResponse> =>
  api.post<SendSmsResponse>(`/api/employees/${employeeId}/tsd-login-sms`);

export const getSmsAvailableAt = (reason: unknown): string | undefined => {
  if (!isApiError(reason)) return;
  const payload = reason.payload;
  if (
    typeof payload === 'object' &&
    payload !== null &&
    'availableAt' in payload &&
    typeof payload.availableAt === 'string'
  )
    return payload.availableAt;
};

export const isSessionInactiveError = (reason: unknown): boolean => {
  if (!isApiError(reason) || reason.status !== 409) return false;
  const payload = reason.payload;
  return (
    typeof payload === 'object' &&
    payload !== null &&
    'hasActiveSession' in payload &&
    payload.hasActiveSession === false
  );
};
